export default "__VITE_ASSET__CNysHmrv__"